import React, { useEffect, useRef, useState } from "react"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { Col, Row, Card, UncontrolledPopover, PopoverBody } from "reactstrap"
import UpdateTable from "../../../components/Common/UpdatedTable"
import action from "../../../assets/icons/action.svg"
import { toastSuccess } from "../../../helpers/msg_helper"
import SupplierFilter from "./filter"
import { Link, useLocation, useNavigate } from "react-router-dom"
import {
  fetchHrmsGradeControl,
  updateGradeControlStatus,
} from "../../../services/Hrms/hrms"
import capitalizeFirstLetter from "../../../utils/capitalizeFirstLetter"

const GradeControl = () => {
  const companyname = localStorage.getItem('companyname')
  document.title = `Grade Control${companyname ? ` | ${companyname}` : ''}`;

  const locations = useLocation();
  const crumb = locations?.state?.menuLabel || ""

  const navigate = useNavigate()
  const [refresh, setRefresh] = useState(0)
  const [classData, setClassData] = useState()
  const [status, setStatus] = useState("")
  const [search, setSearch] = useState("")
  const [country, setCountry] = useState("")
  const [page, setPage] = useState("")
  const [isLoadingNextPage, setIsLoadingNextPage] = useState(false)

  const handleActivate = item => {
    const updateStatus = async item => {
      const response = await updateGradeControlStatus(item)
      toastSuccess(response?.message)
      setRefresh(refresh + 1)
    }
    updateStatus(item)
  }

  const columns = [
    {
      label: "Grade Code",
      renderCell: item => {
        return (
          <div
          // onClick={() => navigate(`/procurement-supplier/view/${item?.id}`)}
          // className="pointer fw-bold"
          >
            {item?.grade?.grade
              ? capitalizeFirstLetter(item?.grade?.grade)
              : "-"}
          </div>
        )
      },
    },
    {
      label: "Status",
      renderCell: item => (
        <div>
          <span
            className={`font-13 ${item?.status == 1 ? "status-active" : "status-inactive"
              }`}
          >
            {item?.status == 1 ? "Active" : "Inactive"}
          </span>
        </div>
      ),
    },
    {
      label: "Action",
      renderCell: item => (
        <>
          <div>
            <span id={`PopoverLegacy-${item?.id}`}>
              <img src={action} alt="" className="pointer" />
            </span>
          </div>
          <UncontrolledPopover
            placement="bottom"
            target={`PopoverLegacy-${item?.id}`}
            trigger="legacy"
          >{console.log(`item?.grade_id`, item?.grade_id)
            }
            <PopoverBody>
              {item?.status == 1 && (
                <div
                  className="table-popup-content"
                  onClick={() =>
                    navigate(`/hrms-grade-control/${item?.grade_id}`)
                  }
                >
                  Edit
                </div>
              )}
              <div
                className={`${item?.status == 1 ? "popover-border" : ""
                  } table-popup-content`}
                onClick={() => handleActivate(item?.grade_id)}
              >
                {item?.status == 1 ? "Deactivate" : "Activate"}
              </div>
            </PopoverBody>
          </UncontrolledPopover>
        </>
      ),
    },
  ]

  const handlePaginate = page => {
    setPage(page)
  }

  useEffect(() => {
    const fetchClass = async () => {
      const response = await fetchHrmsGradeControl({
        params: `${status == "0" || status == "1" ? `&status=${status}` : ""}${search ? `&searchText=${search}` : "&searchText"
          }${`&sortOrder=asc`}${country ? `&country_id=${country}` : ""}${page ? `&page=${page}` : ""
          }${`&sizePerPage=16`}`,
      })
      // setClassData(response)
      const newData = response?.data?.data || [];

      setClassData(prev =>
        page > 1 && prev
          ? {
            ...response,
            data: {
              ...response.data,
              data: [...(prev.data?.data || []), ...newData],
            },
          }
          : response
      );
      setIsLoadingNextPage(response == undefined ? true : false)
      isLoadingRef.current = false;
    }
    fetchClass()
  }, [refresh, status, search, country, page])

  const tableContainerRef = useRef(null)
  const isLoadingRef = useRef(false);
  const scrollTimeoutRef = useRef(null);

  useEffect(() => {
    const handleScroll = (e) => {
      const { scrollTop, scrollHeight, clientHeight } = e.target;
      
      if (scrollTimeoutRef.current) {
        clearTimeout(scrollTimeoutRef.current);
      }
      
      scrollTimeoutRef.current = setTimeout(() => {
        if (
          scrollTop + clientHeight >= scrollHeight - 50 &&
          !isLoadingRef.current &&
          page < classData?.data?.last_page
        ) {
          isLoadingRef.current = true;
          setIsLoadingNextPage(true);
          setPage(prev => prev + 1);
        }
      }, 200);
    };
    
    const container = tableContainerRef.current;
    if (container) {
      container.addEventListener("scroll", handleScroll);
    }
    
    return () => {
      if (container) {
        container.removeEventListener("scroll", handleScroll);
      }
      if (scrollTimeoutRef.current) {
        clearTimeout(scrollTimeoutRef.current);
      }
    };
  }, [classData, page]);

  const handleStatusChange = id => {
    setStatus(id)
    setPage(1)
  }
  const handleCountryChange = id => {
    setCountry(id)
    setPage(1)
  }
  const handleSearchChange = data => {
    setSearch(data)
    setPage(1)
  }
  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <div className="d-flex justify-content-between">
            <Breadcrumbs
              title="Procurement"
              breadcrumbObject={[
                { title: "HRMS", link: "/hrms" },
                { title: crumb || "Masters", link: "/hrms" },
                { title: "Grade Control", link: "/hrms-grade-control" },
              ]}
            />
            <Link
              to="/hrms-grade-control/add"
              className={"px-2 mb-3 me-2 btn btn-primary"}
            >
              {"+ Grade"}
            </Link>
          </div>
          <Card className="me-2 px-2 pb-2">
            <SupplierFilter
              handleStatusChange={handleStatusChange}
              handleSearchChange={handleSearchChange}
              handleCountryChange={handleCountryChange}
              sampleUrl={"download/suppliers.xlsx"}
              importUrl={"suppliers/import"}
              isImport={false}
            />
            <hr className="table-divide" />
            <Row className="mt-2 ever-rise-table">
              <Col xs={12}>
              <div ref={tableContainerRef} style={{ maxHeight: "490px", overflowY: "auto" }}>
                {classData && (
                  <UpdateTable
                    className="mt-5"
                    nodes={classData?.data?.data}
                    paginate={classData?.data}
                    columns={columns}
                    CurrentPage={page}
                    handlePagination={handlePaginate}
                    tableWidth="40% 40% 20%"
                    isLoading={isLoadingNextPage}
                    hidePaginate={true}
                  />
                )}
                </div>
              </Col>
            </Row>
          </Card>
        </div>
      </div>
    </React.Fragment>
  )
}

export default GradeControl
